import { ReactNode } from 'react';

export enum TStatusCountIcon {
  Red,
  Yellow,
  Blue,
}

export interface IStatusCountProps {
  className?: string;
  icon: TStatusCountIcon;
  count: number;
  children: ReactNode;
}
